import Popup from "../../lib/Popup";

import * as PIXI from "pixi.js";
import { IGameSnacks } from "../../lib/GameSnacks";
import ServiceLocator from "../../ServiceLocator";
import Utils from "../../Utils";
import Button from "../../lib/Button";
import { Profile } from "../../lib/game_snacks/IUser";
import Session, { game_type } from "../../Session";

declare global {
    interface Window { GameSnacks: IGameSnacks; }
}


export default class ProfileRequiredPopup extends Popup
{
    // #region Attributes //

    // private:

    private _selGameType: game_type = null;

    // #endregion //


    public set selGameType( value: game_type ) { this._selGameType = value; }


    // #region Methods //

    // public:

    public onEnter(): void
    {
        super.onEnter();        

        console.assert( this._selGameType != null, "ProfileRequiredPopup.ts :: onEnter() :: this:_selGameType cannot be null." );

        let base: PIXI.Sprite = new PIXI.Sprite( ServiceLocator.resources.popup_base.texture );
        base.position.set( ServiceLocator.app.width * 0.5 - base.texture.width * 0.5, ServiceLocator.app.height * 0.5 - base.height * 0.5 );
        this._root.addChild( base );

        let messageText: PIXI.Text = new PIXI.Text( "You need a profile to play online.", { 
            fontFamily: "asap_regular", 
            fontSize: 38, 
            fill: 0xffffdf,
            wordWrap: true,
            wordWrapWidth: ServiceLocator.app.width * 0.8,
            align: "center" } );
        messageText.anchor.set( 0.5 );
        messageText.position.set( base.texture.width * 0.5, 194 );
        base.addChild( messageText );

        let createBtn: Button = new Button( { on: "popup_button_green" } );
        createBtn.anchor.set( 0.5 );
        createBtn.position.set( base.texture.width * 0.5, 350 );
        base.addChild( createBtn );
        createBtn.on( "pointertap", () => { this._onClosed.dispatch( this, null ); } );
        //
        let text: PIXI.Text = new PIXI.Text( "OK", { 
            fontFamily: "asap_extrabold", 
            fontSize: 30, 
            fill: 0xffffdf } );
        text.anchor.set( 0.5 );
        createBtn.addChild( text );
    }

    // #endregion //
}
